/**
 * Metafans Profile & Group Header Logic
 * Handles dynamic updates for Cover Images and Avatars.
 */

export function initProfile() {
    // Ensure jQuery is available as BP uses it for triggers
    if (typeof jQuery === 'undefined') return;

    const body = jQuery('body');

    // 1. Listen for Cover Image Upload Success
    // BuddyPress triggers 'bp_cover_image_saved' with the new image data
    body.on('bp_cover_image_saved', (event, response) => {
        if (response && response.url) {
            updateCoverImage(response.url);
        }
    });

    // 2. Listen for Avatar Upload Success (Optional enhancement)
    body.on('bp_avatar_saved', (event, response) => {
        if (response && response.avatar) {
            updateAvatar(response.avatar);
        }
    });
}

/**
 * Updates the Cover Image background immediately.
 * Adds a timestamp to the URL to bypass browser caching.
 */
function updateCoverImage(url) {
    const selectors = [
        '#header-cover-image',      // Standard Profile
        '#cover-image-container',   // Container fallback
        '.bp-group-cover-image',    // Group Headers
        '.bp-user-cover-image'      // User Headers
    ];

    // Force cache break
    const cleanUrl = url.split('?')[0];
    const newUrl = `${cleanUrl}?t=${Date.now()}`;

    selectors.forEach(selector => {
        const el = document.querySelector(selector);
        if (el) {
            el.style.backgroundImage = `url('${newUrl}')`;
            el.style.backgroundSize = 'cover';
            el.style.backgroundPosition = 'center center';

            // Visual feedback
            el.classList.add('updated');
            setTimeout(() => el.classList.remove('updated'), 500);
        }
    });
}

function updateAvatar(url) {
    const avatars = document.querySelectorAll('#item-header-avatar img.avatar, .bp-activity-avatar-change img.avatar');
    avatars.forEach(img => {
        img.src = url;
        img.srcset = ''; // Clear srcset to prevent loading old size
    });
}